<template>
  <v-app-bar
    :color="'blue-darken-3'"
    theme="dark"
    elevation="0"
    app
    density="compact"
  >
    <v-toolbar-title class="flex-grow-0 flex-shrink-0"></v-toolbar-title>

    <router-link
      v-if="$store.getters.authenticated"
      to="/sarah-walker/conversations"
      class="nav-logo-link mr-3 d-inline-flex"
      title="Sarah Walker"
    >
      <v-avatar
        size="30"
        color="blue-darken-3"
        class="nav-logo-avatar"
      >
        <v-img
          src="../../assets/logo-white-30.png"
          max-width="30"
          max-height="30"
          contain
        ></v-img>
      </v-avatar>
    </router-link>

    <base-main-nav-btn
      v-if="$store.getters.authenticated"
      to="/"
      icon="mdi-view-dashboard"
    >Dashboard</base-main-nav-btn>

    <v-menu
      :theme="dropdownTheme"
      v-if="$store.getters.authenticated"
      location="bottom start"
    >
      <template #activator="{ props }">
        <base-main-nav-btn
          icon="mdi-domain"
          v-bind="props"
        >
          <v-icon class="mr-1" size="small">mdi-domain</v-icon>
          Accounts
          <v-icon>mdi-menu-down</v-icon>
        </base-main-nav-btn>
      </template>

      <v-list
        density="compact"
      >
        <v-list-subheader>
          <v-icon size="small" class="mr-1">mdi-domain</v-icon>
          Accounts
        </v-list-subheader>

        <v-divider></v-divider>

        <v-list-item
          to="/accounts"
        >
          <v-list-item-title>Accounts</v-list-item-title>
          <template #append>
            <v-icon size="small">mdi-domain</v-icon>
          </template>
        </v-list-item>

        <v-list-item
          to="/users"
        >
          <v-list-item-title>Users</v-list-item-title>
          <template #append>
            <v-icon size="small">mdi-account-group</v-icon>
          </template>
        </v-list-item>

        <v-divider></v-divider>

        <v-list-item
          to="/admins"
        >
          <v-list-item-title>Admins</v-list-item-title>
          <template #append>
            <v-icon size="small">mdi-shield-account</v-icon>
          </template>
        </v-list-item>
      </v-list>
    </v-menu>

    <v-menu
      :theme="dropdownTheme"
      v-if="$store.getters.authenticated"
      location="bottom start"
    >
      <template #activator="{ props }">
        <base-main-nav-btn
          icon="mdi-wrench"
          v-bind="props"
        >
          <v-icon class="mr-1" size="small">mdi-wrench</v-icon>
          Maintenance
          <v-icon>mdi-menu-down</v-icon>
        </base-main-nav-btn>
      </template>

      <v-list
        density="compact"
      >
        <v-list-subheader>
          <v-icon size="small" class="mr-1">mdi-wrench</v-icon>
          Maintenance
        </v-list-subheader>

        <v-divider></v-divider>

        <v-list-item
          to="/server-metrics"
        >
          <v-list-item-title>Server Metrics</v-list-item-title>
          <template #append>
            <v-icon size="small">mdi-thermometer</v-icon>
          </template>
        </v-list-item>

        <v-list-item
          to="/logs"
        >
          <v-list-item-title>Logs</v-list-item-title>
          <template #append>
            <v-icon size="small">mdi-text-box-outline</v-icon>
          </template>
        </v-list-item>

        <v-list-item
          to="/database"
        >
          <v-list-item-title>Database</v-list-item-title>
          <template #append>
            <v-icon size="small">mdi-database-outline</v-icon>
          </template>
        </v-list-item>

        <v-list-item
          to="/queues"
        >
          <v-list-item-title>Queues</v-list-item-title>
          <template #append>
            <v-icon size="small">mdi-tray-full</v-icon>
          </template>
        </v-list-item>

        <v-list-item
          to="/performance"
        >
          <v-list-item-title>Performance</v-list-item-title>
          <template #append>
            <v-icon size="small">mdi-speedometer</v-icon>
          </template>
        </v-list-item>
      </v-list>
    </v-menu>

    <v-menu
      :theme="dropdownTheme"
      v-if="$store.getters.authenticated"
      location="bottom start"
    >
      <template #activator="{ props }">
        <base-main-nav-btn
          icon="mdi-robot-angry"
          v-bind="props"
        >
          <v-icon class="mr-1" size="small">mdi-robot-angry</v-icon>
          Bots
          <v-icon>mdi-menu-down</v-icon>
        </base-main-nav-btn>
      </template>

      <v-list
        density="compact"
      >
        <v-list-subheader>
          <v-icon size="small" class="mr-1">mdi-robot-angry</v-icon>
          Bots
        </v-list-subheader>

        <v-divider></v-divider>

        <v-list-item
          to="/bot-servers"
        >
          <v-list-item-title>Servers</v-list-item-title>
          <template #append>
            <v-icon size="small">mdi-server</v-icon>
          </template>
        </v-list-item>

        <v-list-item
          to="/bots"
        >
          <v-list-item-title>Instances</v-list-item-title>
          <template #append>
            <v-icon size="small">mdi-robot</v-icon>
          </template>
        </v-list-item>

        <v-list-item
          to="/bot-queue"
        >
          <v-list-item-title>Queue</v-list-item-title>
          <template #append>
            <v-icon size="small">mdi-format-list-checks</v-icon>
          </template>
        </v-list-item>

        <v-list-item
          to="/bot-errors"
        >
          <v-list-item-title>Errors</v-list-item-title>
          <template #append>
            <v-icon size="small">mdi-bug</v-icon>
          </template>
        </v-list-item>

        <v-list-item
          to="/bot-view"
        >
          <v-list-item-title>View</v-list-item-title>
          <template #append>
            <v-icon size="small">mdi-desktop-classic</v-icon>
          </template>
        </v-list-item>

        <v-list-item
          to="/bot-grid"
        >
          <v-list-item-title>Grid</v-list-item-title>
          <template #append>
            <v-icon size="small">mdi-view-grid</v-icon>
          </template>
        </v-list-item>
      </v-list>
    </v-menu>

    <v-menu
      :theme="dropdownTheme"
      v-if="$store.getters.authenticated"
      location="bottom start"
    >
      <template #activator="{ props }">
        <base-main-nav-btn
          icon="mdi-robot"
          v-bind="props"
        >
          <v-icon class="mr-1" size="small">mdi-robot</v-icon>
          AI
          <v-icon>mdi-menu-down</v-icon>
        </base-main-nav-btn>
      </template>

      <v-list density="compact">
        <v-list-subheader>
          <v-icon size="small" class="mr-1">mdi-robot</v-icon>
          AI
        </v-list-subheader>

        <v-divider></v-divider>

        <v-list-item to="/ai/conversations">
          <v-list-item-title>AI Chats</v-list-item-title>
          <template #append>
            <v-icon size="small">mdi-robot</v-icon>
          </template>
        </v-list-item>

        <v-list-item to="/ai/llm-requests">
          <v-list-item-title>AI Requests Queue</v-list-item-title>
          <template #append>
            <v-icon size="small">mdi-format-list-checks</v-icon>
          </template>
        </v-list-item>

        <v-list-item to="/ai/message-feedback">
          <v-list-item-title>Webwalker AI Feedback</v-list-item-title>
          <template #append>
            <v-icon size="small">mdi-thumb-up-outline</v-icon>
          </template>
        </v-list-item>

        <v-list-item to="/sarah-walker/message-feedback">
          <v-list-item-title>Sarah Walker Feedback</v-list-item-title>
          <template #append>
            <v-icon size="small">mdi-thumb-up-outline</v-icon>
          </template>
        </v-list-item>
      </v-list>
    </v-menu>

    <base-main-nav-btn
      v-if="$store.getters.authenticated"
      to="/workflows"
    >
      <v-icon class="mr-1" size="small">mdi-cogs</v-icon>
      Workflows
    </base-main-nav-btn>

    <v-menu
      :theme="dropdownTheme"
      v-if="$store.getters.authenticated"
      location="bottom start"
    >
      <template #activator="{ props }">
        <base-main-nav-btn
          icon="mdi-account-box-multiple"
          v-bind="props"
        >
          Contacts
          <v-icon>mdi-menu-down</v-icon>
        </base-main-nav-btn>
      </template>

      <v-list
        density="compact"
      >
        <v-list-subheader>
          <v-icon size="small" class="mr-1">mdi-account-box-multiple</v-icon>
          Contacts
          <base-info-icon
            label="Manage and organize your contact data."
          />
        </v-list-subheader>

        <v-divider></v-divider>

        <v-list-item
          to="/contacts"
        >
          <v-list-item-title>Contacts</v-list-item-title>
          <template #append>
            <v-icon size="small">mdi-contacts</v-icon>
          </template>
        </v-list-item>

        <v-list-item
          to="/companies"
        >
          <v-list-item-title>Companies</v-list-item-title>
          <template #append>
            <v-icon size="small">mdi-briefcase</v-icon>
          </template>
        </v-list-item>

        <v-list-item
          to="/contact-lists"
        >
          <v-list-item-title>Lists</v-list-item-title>
          <template #append>
            <v-icon size="small">mdi-table-account</v-icon>
          </template>
        </v-list-item>

        <v-list-item
          to="/contacts-import"
        >
          <v-list-item-title>Import</v-list-item-title>
          <template #append>
            <v-icon size="small">mdi-cloud-upload</v-icon>
          </template>
        </v-list-item>
      </v-list>
    </v-menu>

    <v-menu
      :theme="dropdownTheme"
      v-if="$store.getters.authenticated && !truncateMenu"
      location="bottom start"
    >
      <template #activator="{ props }">
        <base-main-nav-btn
          icon="mdi-bullseye-arrow"
          v-bind="props"
        >
          <v-icon class="mr-1" size="small">mdi-bullseye-arrow</v-icon>
          CRM
          <v-icon>mdi-menu-down</v-icon>
        </base-main-nav-btn>
      </template>

      <v-list
        density="compact"
      >
        <v-list-subheader>
          <v-icon size="small" class="mr-1">mdi-bullseye-arrow</v-icon>
          CRM
        </v-list-subheader>

        <v-divider></v-divider>

        <v-list-item
          to="/task-boards"
        >
          <v-list-item-title>Tasks</v-list-item-title>
          <template #append>
            <v-icon size="small">mdi-bullseye-arrow</v-icon>
          </template>
        </v-list-item>

        <v-list-item
          to="/notes"
        >
          <v-list-item-title>Notes</v-list-item-title>
          <template #append>
            <v-icon size="small">mdi-note</v-icon>
          </template>
        </v-list-item>

        <v-list-item
          to="/tags"
        >
          <v-list-item-title>Tags</v-list-item-title>
          <template #append>
            <v-icon size="small">mdi-tag</v-icon>
          </template>
        </v-list-item>
      </v-list>
    </v-menu>

    <v-menu
      :theme="dropdownTheme"
      v-if="$store.getters.authenticated"
      v-model="menuLinkedin"
      location="bottom start"
      :close-on-content-click="false"
    >
      <template #activator="{ props }">
        <base-main-nav-btn
          v-bind="props"
        >
          <v-icon class="mr-1" size="small">mdi-linkedin</v-icon>
          LinkedIn
          <v-icon>mdi-menu-down</v-icon>
        </base-main-nav-btn>
      </template>

      <v-list
        density="compact"
      >
        <v-list-subheader>
          <v-icon size="small" class="mr-1">mdi-linkedin</v-icon>
          LinkedIn
          <base-info-icon
            label="Manage your LinkedIn accounts and the related data."
          />
        </v-list-subheader>

        <v-divider></v-divider>

        <v-list-item
          to="/linkedin"
          @click="closeLinkedinMenu"
        >
          <v-list-item-title>Accounts</v-list-item-title>
          <template #append>
            <v-icon size="small">mdi-account-box-multiple</v-icon>
          </template>
        </v-list-item>

        <v-divider></v-divider>

        <v-list-item
          to="/linkedin-profiles"
        >
          <v-list-item-title>Profiles</v-list-item-title>
          <template #append>
            <v-icon size="small">mdi-contacts</v-icon>
          </template>
        </v-list-item>

        <v-divider></v-divider>

        <v-list-item
          to="/linkedin-conversations"
          @click="closeLinkedinMenu"
        >
          <v-list-item-title>Conversations</v-list-item-title>
          <template #append>
            <v-icon size="small">mdi-forum</v-icon>
          </template>
        </v-list-item>

        <v-divider></v-divider>

        <v-list-item
          to="/linkedin-searches"
          @click="closeLinkedinMenu"
        >
          <v-list-item-title>Searches</v-list-item-title>
          <template #append>
            <v-icon size="small">mdi-account-search</v-icon>
          </template>
        </v-list-item>

        <v-divider></v-divider>

        <v-list-item
          to="/linkedin-personas"
          @click="closeLinkedinMenu"
        >
          <v-list-item-title>Personas</v-list-item-title>
          <template #append>
            <v-icon size="small">mdi-account-box-outline</v-icon>
          </template>
        </v-list-item>

        <v-divider></v-divider>

        <v-list-item
          to="/linkedin-priority-companies"
          @click="closeLinkedinMenu"
        >
          <v-list-item-title>Priority Companies</v-list-item-title>
          <template #append>
            <v-icon size="small">mdi-office-building-outline</v-icon>
          </template>
        </v-list-item>

        <v-divider></v-divider>

        <v-list-item
          to="/linkedin-connections"
          @click="closeLinkedinMenu"
        >
          <v-list-item-title>Connections</v-list-item-title>
          <template #append>
            <v-icon size="small">mdi-account-multiple</v-icon>
          </template>
        </v-list-item>

        <v-list-group>
          <template #activator="{ props }">
            <v-list-item v-bind="props">
              <v-list-item-title>Invitations</v-list-item-title>
            </v-list-item>
          </template>

          <v-list-item
            to="/linkedin-invitations-received"
            @click="closeLinkedinMenu"
            class="pl-6"
          >
            <v-list-item-title>Received</v-list-item-title>
          <template #append>
            <v-icon size="small">mdi-account-multiple-plus</v-icon>
          </template>
          </v-list-item>

          <v-list-item
            to="/linkedin-invitations-sent"
            @click="closeLinkedinMenu"
            class="pl-6"
          >
            <v-list-item-title>Sent</v-list-item-title>
          <template #append>
            <v-icon size="small">mdi-account-multiple-plus-outline</v-icon>
          </template>
          </v-list-item>
        </v-list-group>

        <v-list-item
          to="/linkedin-suggestions"
          @click="closeLinkedinMenu"
        >
          <v-list-item-title>Suggestions</v-list-item-title>
          <template #append>
            <v-icon size="small">mdi-account-question</v-icon>
          </template>
        </v-list-item>

        <v-list-item
          to="/linkedin-views"
          @click="closeLinkedinMenu"
        >
          <v-list-item-title>Views</v-list-item-title>
          <template #append>
            <v-icon size="small">mdi-target-account</v-icon>
          </template>
        </v-list-item>

        <v-divider></v-divider>

        <v-list-item
          to="/linkedin-groups"
          @click="closeLinkedinMenu"
        >
          <v-list-item-title>Groups</v-list-item-title>
          <template #append>
            <v-icon size="small">mdi-account-group</v-icon>
          </template>
        </v-list-item>

        <v-divider></v-divider>

        <v-list-group>
          <template #activator="{ props }">
            <v-list-item v-bind="props">
              <v-list-item-title>LinkedIn Company Page</v-list-item-title>
            </v-list-item>
          </template>

          <v-list-item
            @click="closeLinkedinMenu"
            class="pl-6"
            :disabled="true"
          >
            <v-list-item-title>Posts</v-list-item-title>
            <template #append>
              <v-icon size="small">mdi-note-text</v-icon>
            </template>
          </v-list-item>

          <v-list-item
            @click="closeLinkedinMenu"
            class="pl-6"
            :disabled="true"
          >
            <v-list-item-title>Invitations Sent</v-list-item-title>
          <template #append>
            <v-icon size="small">mdi-briefcase-plus</v-icon>
          </template>
          </v-list-item>
        </v-list-group>
      </v-list>
    </v-menu>

    <v-menu
      :theme="dropdownTheme"
      v-if="$store.getters.authenticated && !truncateMenu"
      location="bottom start"
    >
      <template #activator="{ props }">
        <base-main-nav-btn
          v-bind="props"
        >
          <v-icon class="mr-1" size="small">mdi-wrench</v-icon>
          Integrations
          <v-icon>mdi-menu-down</v-icon>
        </base-main-nav-btn>
      </template>

      <v-list
        density="compact"
      >
        <v-list-subheader>
          <v-icon size="small" class="mr-1">mdi-wrench</v-icon>
          Integrations
        </v-list-subheader>

        <v-divider></v-divider>

        <v-list-item
          to="/integrations"
        >
          <v-list-item-title>API Integrations</v-list-item-title>
          <template #append>
            <v-icon size="small">mdi-api</v-icon>
          </template>
        </v-list-item>

        <v-list-item
          to="/webhooks"
        >
          <v-list-item-title>Webhooks</v-list-item-title>
          <template #append>
            <v-icon size="small">mdi-webhook</v-icon>
          </template>
        </v-list-item>
      </v-list>
    </v-menu>

    <v-menu
      :theme="dropdownTheme"
      v-if="$store.getters.authenticated && !truncateMenuL1"
      location="bottom start"
    >
      <template #activator="{ props }">
        <base-main-nav-btn
          icon="mdi-chart-box"
          v-bind="props"
        >
          <v-icon class="mr-1" size="small">mdi-chart-box</v-icon>
          Reports
          <v-icon>mdi-menu-down</v-icon>
        </base-main-nav-btn>
      </template>

      <v-list
        density="compact"
      >
        <v-list-subheader>
          <v-icon size="small" class="mr-1">mdi-chart-box</v-icon>
          Reports
          <base-info-icon
            label="Track and measure performance of your account."
          />
        </v-list-subheader>

        <v-divider></v-divider>

        <v-list-item
          to="/overview"
        >
          <v-list-item-title>Overview</v-list-item-title>
          <template #append>
            <v-icon size="small">mdi-calendar</v-icon>
          </template>
        </v-list-item>

        <v-list-item
          to="/reports"
        >
          <v-list-item-title>Charts</v-list-item-title>
          <template #append>
            <v-icon size="small">mdi-chart-areaspline</v-icon>
          </template>
        </v-list-item>
      </v-list>
    </v-menu>

    <v-menu
      :theme="dropdownTheme"
      v-if="$store.getters.authenticated && truncateMenu"
      location="bottom start"
    >
      <template #activator="{ props }">
        <base-main-nav-btn
          icon="mdi-table"
          v-bind="props"
        >
          <span v-if="!truncateMenuL3">More</span>
          <v-icon>mdi-menu-down</v-icon>
        </base-main-nav-btn>
      </template>

      <v-list
        density="compact"
      >
        <v-list-item
          to="/task-boards"
        >
          <v-list-item-title>Tasks</v-list-item-title>
          <template #append>
            <v-icon size="small">mdi-bullseye-arrow</v-icon>
          </template>
        </v-list-item>

        <v-list-item
          to="/notes"
        >
          <v-list-item-title>Notes</v-list-item-title>
          <template #append>
            <v-icon size="small">mdi-note</v-icon>
          </template>
        </v-list-item>

        <v-list-item
          to="/tags"
        >
          <v-list-item-title>Tags</v-list-item-title>
          <template #append>
            <v-icon size="small">mdi-tag</v-icon>
          </template>
        </v-list-item>

        <v-divider></v-divider>

        <v-list-subheader>
          <v-icon size="small" class="mr-1">mdi-chart-box</v-icon>
          Reports
          <base-info-icon
            label="Track and measure performance of your account."
          />
        </v-list-subheader>

        <v-list-item
          to="/overview"
        >
          <v-list-item-title>Overview</v-list-item-title>
          <template #append>
            <v-icon size="small">mdi-calendar</v-icon>
          </template>
        </v-list-item>

        <v-list-item
          to="/reports"
        >
          <v-list-item-title>Charts</v-list-item-title>
          <template #append>
            <v-icon size="small">mdi-chart-areaspline</v-icon>
          </template>
        </v-list-item>

        <v-divider></v-divider>

        <v-list-subheader>
          <v-icon size="small" class="mr-1">mdi-wrench</v-icon>
          Integrations
        </v-list-subheader>

        <v-list-item
          to="/integrations"
        >
          <v-list-item-title>API Integrations</v-list-item-title>
          <template #append>
            <v-icon size="small">mdi-api</v-icon>
          </template>
        </v-list-item>

        <v-list-item
          to="/webhooks"
        >
          <v-list-item-title>Webhooks</v-list-item-title>
          <template #append>
            <v-icon size="small">mdi-webhook</v-icon>
          </template>
        </v-list-item>
      </v-list>
    </v-menu>

    <v-btn
      v-if="$store.getters.authenticated"
      to="/sarah-walker/conversations"
      icon
      class="mx-1"
      size="small"
    >
      <v-icon>mdi-crown</v-icon>
    </v-btn>

    <v-spacer></v-spacer>

    <main-nav-notifications
      v-if="$store.getters.authenticated"
    ></main-nav-notifications>

    <v-btn
      v-if="$store.getters.authenticated"
      to="/settings"
      icon
      class="mx-1"
      size="small"
    >
      <v-icon size="small">mdi-account-circle</v-icon>
    </v-btn>

    <div
      v-if="$store.getters.authenticated"
    >
      <v-tooltip location="bottom" v-if="$store.state.isDarkMode" >
        <template #activator="{ props }">
          <v-btn v-bind="props" size="small" icon @click="$store.dispatch('switchDarkMode', false)">
            <v-icon size="small" color="yellow" class="mr-1">mdi-moon-waxing-crescent</v-icon>
          </v-btn>
        </template>
        <span>Disable dark mode</span>
      </v-tooltip>
      <v-tooltip location="bottom" v-else >
        <template #activator="{ props }">
          <v-btn v-bind="props" size="small" icon @click="$store.dispatch('switchDarkMode', true)">
            <v-icon size="small" color="yellow">mdi-white-balance-sunny</v-icon>
          </v-btn>
        </template>
        <span>Enable dark mode</span>
      </v-tooltip>
    </div>

    <v-divider
      v-if="$store.getters.authenticated"
      v-show="!this.isAuthView"
      vertical
      class="ml-2"
    ></v-divider>

    <v-btn
      class="main-nav-btn mx-2"
      size="small"
      variant="text"
      v-if="!this.$store.getters.authenticated"
      :to="{name: 'Login'}"
    >
      <v-icon class="mr-1" size="small">mdi-login</v-icon>
      Login
    </v-btn>
    <v-btn
      class="mx-2"
      icon
      size="small"
      v-if="this.$store.getters.authenticated"
      @click="logoutConfirmation = true"
    >
      <v-icon size="small">mdi-logout</v-icon>
    </v-btn>
    <base-dialog-confirmation
      v-model="logoutConfirmation"
      prompt="Do you really want to logout?"
      confirm-text="Logout"
      confirm-color="red"
      @confirm="logout"
      @cancel="logoutConfirmation = false"
    ></base-dialog-confirmation>
  </v-app-bar>
</template>

<script>
import MainNavNotifications from '@/components/layout/MainNavNotifications.vue';

export default {
  name: 'MainNavV2',

  components: {
    MainNavNotifications,
  },

  data() {
    return {
      logoutConfirmation: false,
      menuLinkedin: false,
      truncateMenu: false,
      truncateMenuL1: false,
      truncateMenuL2: false,
      truncateMenuL3: false,
    };
  },

  computed: {
    dropdownTheme() {
      return this.$store.state.isDarkMode ? 'dark' : 'light';
    },

    isAuthView() {
      // Check if on auth pages (login, sign up, password reset, etc)
      if (this.$route && this.$route.meta) {
        return this.$route.meta.public;
      }
      return false;
    },
  },

  created() {
    this.resizeScreen();
    window.addEventListener("resize", this.resizeScreen);
  },
  unmounted() {
    window.removeEventListener("resize", this.resizeScreen);
  },

  methods: {

    logout: function () {
      this.$emit('logout');
    },

    resizeScreen: function () {
      this.truncateMenu = window.innerWidth < 1600;
      this.truncateMenuL1 = window.innerWidth < 1300;
      this.truncateMenuL2 = window.innerWidth < 1200;
      this.truncateMenuL3 = window.innerWidth < 1050;
    },

    closeLinkedinMenu: function () {
      this.menuLinkedin = false;
    },

  },
};
</script>
